import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CERTIFICADO_EMISSAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CERTIFICADO_EMISSAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('certificadoEmissaoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/certificadoEmissao?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'CERTIFICADO_EMISSAO_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			
			dispatch(setAguardando(true));

			let erro = false;

			let idsIncluidos = [];
			
			if (registro.id_origem == 1 || registro.id_origem == 3) { //Checklist de Treinamento ou Avulso

				if (registro.id_checklist_resposta) {

					const checklistResposta = getState().certificadoEmissao.listaChecklistResposta.filter(item => item.id == registro.id_checklist_resposta)[0];

					if (checklistResposta) {
						registro = {
							...registro,
							nome_cliente: checklistResposta.nome_cliente
						};
					}

					let participantes = [];				

					await axios.get(`${consts.API_URL}/checklistRespostaItem/detalhado?id_checklist_resposta=${registro.id_checklist_resposta}`).then(async result => {
						for (let i = 0; i < result.data.length; i++) {
							const item = result.data[i];

							if (!registro.data_inicio && (
								item.descricao_item.toUpperCase() == 'Início - Data'.toUpperCase() 
								|| item.descricao_item.toUpperCase() == 'INICIO - Fecha'.toUpperCase()
								|| item.descricao_item.toUpperCase() == 'Start - Date'.toUpperCase()
							)) {
								registro = {
									...registro,
									data_inicio: item.resposta
								};
							}

							if (!registro.data_fim && (
								item.descricao_item.toUpperCase() == 'Término - Data'.toUpperCase() 
								|| item.descricao_item.toUpperCase() == 'FIN - Fecha'.toUpperCase() 
								|| item.descricao_item.toUpperCase() == 'Finish - Date'.toUpperCase()
							)) {
								registro = {
									...registro,
									data_fim: item.resposta
								};
							}

							if (!registro.data_fim && (
								item.descricao_item.toUpperCase() == 'Carga Horária (h):'.toUpperCase() 
								|| item.descricao_item.toUpperCase() == 'Carga de Trabajo (h):'.toUpperCase()
								|| item.descricao_item.toUpperCase() == 'Training Hours (h)'.toUpperCase()
							)) {
								registro = {
									...registro,
									carga_horaria: item.resposta
								};
							}

							if (
								item.descricao_item.toUpperCase() == 'Tópicos do Treinamento:'.toUpperCase() 
								|| item.descricao_item.toUpperCase() == 'Temas del Entrenamiento:'.toUpperCase()
								|| item.descricao_item.toUpperCase() == 'Training Topics'.toUpperCase()
							) {
								let modulos = [];
								(item.resposta || []).forEach(idResposta => {
									
									item.opcoes.substring(1, item.opcoes.length - 2).split(`","`).forEach(opcao => {
										if (JSON.parse(opcao.replace(`"{`, '{').split('\\').join('')).id == idResposta) {
											modulos.push(JSON.parse(opcao.replace(`"{`, '{').split('\\').join('')).nome);
										}
									});									
								});

								registro = {
									...registro,
									modulos: modulos
								};								
							}
						}

						if (registro.id_origem == 1) { //Checklist
							for (let i = 0; i < result.data.length; i++) {
								const item = result.data[i];

								if (item.nome_area && item.nome_area.toUpperCase().includes('PARTICIPANT')) {
									if (!participantes.filter(participante => participante.id == item.nome_area).length) {
										participantes.push({
											id: item.nome_area
										});
									}
									if (item.resposta && (
										item.descricao_item == 'Nome'
										|| item.descricao_item == 'Nome:' 
										|| item.descricao_item == 'Nombre :'
										|| item.descricao_item == 'Nombre:'
										|| item.descricao_item == 'Name:'
									)) {
										
										participantes = participantes.map(participante => {
											if (participante.id == item.nome_area) {
												return {
													...participante,
													nome_aluno: item.resposta,
													assinatura_aluno: item.complemento_assinatura && item.complemento_assinatura[0] ? item.complemento_assinatura[0].assinatura : null
												};
											}
											return participante;
										});
										
									} else if (item.resposta && (
										item.descricao_item == 'Cédula de Identidad:'
										|| item.descricao_item == 'CPF:' 
										|| item.descricao_item == 'CPF' 
										|| item.descricao_item == 'ID:'
									) && item.complemento_assinatura 
										&& item.complemento_assinatura[0] 
										&& item.complemento_assinatura[0].nome
									) {

										participantes = participantes.map(participante => {
											if (participante.id == item.nome_area) {
												return {
													...participante,
													nome_aluno: item.complemento_assinatura && item.complemento_assinatura[0] ? item.complemento_assinatura[0].nome : null,
													assinatura_aluno: item.complemento_assinatura && item.complemento_assinatura[0] ? item.complemento_assinatura[0].assinatura : null
												};
											}
											return participante;
										});
									} 
								}

							}
						} else { //Avulso
							participantes.push({
								nome_aluno: registro.nome_aluno,
								assinatura_aluno: registro.assinatura_aluno
							});
						}

						participantes = participantes.filter(participante => participante.nome_aluno);

						for (let i = 0; i < participantes.length; i++) {
							const participante = participantes[i];
							
							await axios.post(`${consts.API_URL}/certificadoEmissao`, {
								...registro,
								nome_aluno: participante.nome_aluno,
								assinatura_aluno: participante.assinatura_aluno,
								data_emissao: DateFormat.getDataAtual(),
								id_usuario_inclusao: getState().auth.usuario.id,
								id_usuario_alteracao: getState().auth.usuario.id
							}).then(resp => {
								idsIncluidos.push(resp.data.id);
							}).catch(e => {
								erro = true;
								setErroAPI(e);
							});
							
						}

					}).catch(e => {
						console.log(e);
					});
				}
			} else if (registro.id_origem == 2) { //KeplerFlix

				for (let i = 0; i < registro.listaKeplerFlix.length; i++) {
					const participante = registro.listaKeplerFlix[i];
					
					await axios.post(`${consts.API_URL}/certificadoEmissao`, {
						...registro,
						nome_aluno: participante.aluno,
						email: participante.email,
						curso: participante.curso,
						data_emissao: participante.data_emissao,
						id_usuario_inclusao: getState().auth.usuario.id,
						id_usuario_alteracao: getState().auth.usuario.id
					}).then(resp => {
						idsIncluidos.push(resp.data.id);
					}).catch(e => {
						erro = true;
						setErroAPI(e);
					});
				}

			}
			
			if (!erro) {				
				await axios.get(`${consts.API_URL}/certificadoEmissao/gerarZip?${idsIncluidos.map((id, i) => i == 0 ? `ids=${id}` : `&ids=${id}`).join('')}`, {
					responseType: 'arraybuffer'
				}).then(resp => {

					const blob = new Blob([resp.data], { type: 'application/zip' });
					const link = document.createElement('a');

					link.href = window.URL.createObjectURL(blob);
					link.download = 'certificados.zip';
					link.click();
					URL.revokeObjectURL(link.href);

				}).catch(ex => {
					console.log(ex);
				});

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}

			dispatch(setAguardando(false));
		} else {
			axios.put(`${consts.API_URL}/certificadoEmissao`, {
				...registro,
				cpf_cnpj: FormatUtils.removerMascara(registro.cpf_cnpj),
				cep: FormatUtils.removerMascara(registro.cep),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/certificadoEmissao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getQRCode(token) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'CERTIFICADO_EMISSAO_QRCODE_SELECT_LISTADO',
			payload: { data: null }
		});

        axios.get(`${consts.API_URL}/certificadoEmissao/qrcode?token_certficado=${token}`)
		.then(resp => {
			dispatch({
				type: 'CERTIFICADO_EMISSAO_QRCODE_SELECT_LISTADO',
				payload: { data: resp.data }
			});
		}).catch(e => {
			console.log(e);
			
			setErroAPI(e);
		});
    };
}

export function getListaChecklistResposta() {
    const request = axios.get(`${consts.API_URL}/certificadoEmissao/listarChecklistSelect`);
    return {
        type: 'CERTIFICADO_EMISSAO_CHECKLIST_RESPOSTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaModelo() {
    const request = axios.get(`${consts.API_URL}/certificadoModelo/listarSelect`);
    return {
        type: 'CERTIFICADO_EMISSAO_MODELO_SELECT_LISTADO',
        payload: request
    };
}

export function importar(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));
		
		let listaCidade = [];
		await axios.get(`${consts.API_URL}/cidade/listarSelectGeral`).then(result => {
			listaCidade = result.data;
		});
		
		let listaGrupo = [];
		await axios.get(`${consts.API_URL}/grupoCertificadoEmissao/listarSelect`).then(result => {
			listaGrupo = result.data;
		});

		let listaGruposImportar = [];
		for (var i = 1; i < tabela.length; i++) {
			let item = tabela[i];

			if (!listaGruposImportar.includes(String(String(item[5] || '').trim())) 
				&& !listaGrupo.filter(grupo => grupo.valor == String(String(item[5] || '').trim())).length) {
				listaGruposImportar.push(String(String(item[5] || '').trim()));
				
				// await axios.post(`${consts.API_URL}/grupoCertificadoEmissao`, {
				// 	nome: (String(String(item[5] || '').trim())),
				// 	id_usuario_inclusao: getState().auth.usuario.id,
				// 	id_usuario_alteracao: getState().auth.usuario.id
				// });
			}
		}

		await axios.get(`${consts.API_URL}/grupoCertificadoEmissao/listarSelect`).then(result => {
			listaGrupo = result.data;
		});

		let listaCertificadoEmissao = [];
		await axios.get(`${consts.API_URL}/certificadoEmissao`).then(result => {
			listaCertificadoEmissao = result.data;
		});

		let removerAcento = str => {
			return str.normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "") // Remove diacríticos (acentos)
              .replace(/[çÇ]/g, "c")           // Substitui ç e Ç por c
              .replace(/[^\w\s]/g, "")
		}

		let listaCertificadoEmissaosImportar = [];
		for (var i = 1; i < tabela.length; i++) {
			let item = tabela[i];

			let certificadoEmissao = {

				id_integracao: String(String(item[0] || '').trim()),
				nome: String(String(item[1] || '').trim()),
				cpf_cnpj: FormatUtils.removerMascara(item[2] ? String(String(item[2] || '').trim().padStart('0', 14)) : String(String(item[3] || '').trim().padStart('0', 11))),
				inscricao_estadual: String(item[4] || '').trim(),
				id_grupo: listaGrupo.filter(grupo => grupo.valor.toUpperCase() == String(String(item[5] || '').toUpperCase().trim()))[0] 
						? listaGrupo.filter(grupo => grupo.valor.toUpperCase() == String(String(item[5] || '').toUpperCase().trim()))[0].id : null,
				id_cidade: listaCidade.filter(cidade => removerAcento(cidade.valor.toUpperCase().replace("'", '')) == removerAcento(String(String(item[7] || '').toUpperCase().replace("'", '').trim())))[0] 
						? listaCidade.filter(cidade => removerAcento(cidade.valor.toUpperCase().replace("'", '')) == removerAcento(String(String(item[7] || '').toUpperCase().replace("'", '').trim())))[0].id : null,
				endereco: String(String(item[8] || '').trim()),
				// numero: String(String(item[9] || '').trim()).length > 10 ? '' : String(String(item[9] || '').trim()),
				// bairro: String(String(item[10] || '').trim()),
				cep: '',
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			};

			// if (!certificadoEmissao.id_cidade) {
			// 	console.log(`UPDATE certificadoEmissao SET id_cidade = ${certificadoEmissao.id_cidade} WHERE id_integracao = ${certificadoEmissao.id_integracao} and id_cidade is null;`);
			// }
			

			if (certificadoEmissao.id_integracao
				&& certificadoEmissao.id_grupo 
				&& !listaCertificadoEmissaosImportar.includes(certificadoEmissao.id_integracao) 
				&& !listaCertificadoEmissao.filter(certificadoEmissaoAux => certificadoEmissaoAux.id_integracao == certificadoEmissao.id_integracao).length) {
					listaCertificadoEmissaosImportar.push(certificadoEmissao.id_integracao);
					console.log(listaCertificadoEmissaosImportar.length);
					console.log(certificadoEmissao);

				await axios.post(`${consts.API_URL}/certificadoEmissao`, {
					...certificadoEmissao,
					id_usuario_inclusao: getState().auth.usuario.id,
					id_usuario_alteracao: getState().auth.usuario.id
				}).then(resp => {
					console.log(`Incluido ${i+ 1} de ${tabela.length}`);
				}).catch(e => {
					console.log(e);
				});
				
			} else if (certificadoEmissao.id_integracao
				&& certificadoEmissao.id_grupo 
				&& listaCertificadoEmissao.filter(certificadoEmissaoAux => certificadoEmissaoAux.id_integracao == certificadoEmissao.id_integracao).length) {
					listaCertificadoEmissaosImportar.push(certificadoEmissao.id_integracao);
					
				const certificadoEmissaoCadastrado = listaCertificadoEmissao.filter(certificadoEmissaoAux => certificadoEmissaoAux.id_integracao == certificadoEmissao.id_integracao)[0];

				if (certificadoEmissaoCadastrado.id_grupo != certificadoEmissao.id_grupo
					|| certificadoEmissaoCadastrado.inscricao_estadual != certificadoEmissao.inscricao_estadual
					|| certificadoEmissaoCadastrado.id_cidade != certificadoEmissao.id_cidade
					|| certificadoEmissaoCadastrado.endereco != certificadoEmissao.endereco) {

					await axios.put(`${consts.API_URL}/certificadoEmissao`, {
						...certificadoEmissaoCadastrado,
						id_grupo: certificadoEmissao.id_grupo,
						inscricao_estadual: certificadoEmissao.inscricao_estadual,
						id_cidade: certificadoEmissao.id_cidade,
						endereco: certificadoEmissao.endereco,
						id_usuario_alteracao: getState().auth.usuario.id
					}).then(resp => {
						console.log(`Alterado ${i+ 1} de ${tabela.length}`);
					}).catch(e => {
						console.log(e);
					});
				}
				
			}
						
		}

		setSuccess('Importação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setAguardando(false));
    };
}

export function gerarPdf(registro) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.get(`${consts.API_URL}/certificadoEmissao/gerarPdf?id=${registro.id}`).then(async resp => {
			
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${resp.data.pdf}`;
			link.download = resp.data.filename;
			link.click();
			
			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}

export function getListaCliente() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'CERTIFICADO_EMISSAO_CLIENTE_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaGrupo() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/grupoCliente/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'CERTIFICADO_EMISSAO_GRUPO_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}